/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { get } from 'utils/lodash'

const initialState = {
  columnVisibilityModel: {
    customerBillingProfile: true,
    accountNumber: true,
    customerName: true,
    invoiceNumber: true,
    invoiceDate: true,
    sentDate: true,
    postDate: false,
    postedAmountCents: false,
    amount: true,
    balance: true,
    status: true,
    generationStatus: true,
    wo: false,
    service: false,
    unPostedAmountCents: false,
    lateFees: false,
    paymentNumber: false,
    billingCycleText: false,
    billingTiming: false,
    type: false,
    paymentTermsText: false,
    paper: false,
    pdf: false,
    portal: false,
    receivesPrintedCopy: false,
    deliveryMethod: false,
    customerAddress: false,
    customerCity: false,
    customerState: false,
    customerZip: false,
    tags: true,
    adjustments: false,
    adjustmentsTotal: false,
    legacyPostDate: false,
    legacyPostedAmountCents: false,
  },
}

const persistentInvoicesSlice = createSlice({
  name: 'persistentInvoices',
  initialState: { ...initialState },
  reducers: {
    setPersistentInvoicesColumnVisibilityModel: (state, action) => {
      state.columnVisibilityModel = action.payload
    },
  },
})

export const { setPersistentInvoicesColumnVisibilityModel } = persistentInvoicesSlice.actions

export const selectPersistentInvoicesColumnVisibilityModel = s =>
  get(s, 'persistentInvoices.columnVisibilityModel', initialState.columnVisibilityModel)

export default persistentInvoicesSlice.reducer
